module.exports = __webpack_public_path__ + "img/ide-console.1975867e.svg";